import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import QueryString from "query-string";
import { Drawer, Tabs, Result, Icon, PageHeader, Tag, Button, Row, Col ,Dropdown, Descriptions, message} from "antd";
import { Map, OrderedMap , List} from "immutable";
import CompanyLedgerMaster from "./company-ledger-master-table";
import visibilitySheet from "./visibilitySheet";
import CompanyProfileDisplay from "./company-profile-display";
import DBRiskControl from "./db-risk-control";
import MpaRequest from "./modules/mpa-request";
import CompanyDetailsDisplay from "./company-details-display";
import DeviationMatrixReview from "./deviation-matrix-review";
import CompanyAttachmentsDisplay from "./company-attachments-display";
import CompanyCasesDisplay from "./company-cases-display";
import AgreementTab from "./agreement-tab";
import EsignTab from "./esign-tab";
import CompanySchemeDetailsDisplay from "./company-scheme-details-display";
import CompanyCasesAsSellerDisplay from "./company-cases-seller";
import CompanyDataSyncDisplay from "./company-data-sync-display";
import {
    fetchCompanyLosProfile,
    fetchCompanyLosDetail,
    fetchCompanyLosAttachments,
    updateCompanyLosProfile,
    updateCompanyLosDetail,
    fetchDbRiskControlDetail,
    updateDbRiskControlDetail,
    updateCompanyLosAttachments,
    fetchCompanyLosErps,
    updateCompanyLosErps,
    fetchCompanyLosAnnualTurnovers,
    updateCompanyLosAnnualTurnovers,
    fetchCompanyLosBankingFacilities,
    updateCompanyLosBankingFacilities,
    fetchCompanyLosBrands,
    updateCompanyLosBrands,
    updateCompanyAddress,
    uploadCompanyLosAttachment,
    validateDocument,
    addRetailerMapping,
    fetchRetailerMapping,
    fetchSellerLedgerMaster,
    updateSellerLedgerMaster,
    updateCompanyDisbursalAccount,
    fetchCompanyVisibilitySheetData,
    fetchCaseSellerList,
    invalidateDocument,
} from "./actions";

import { fetchCompanyAllMpa, fetchEnums} from "actions";

import {
    updateCaseType,
    fetchCasePendencyDetail
} from "store/actions";
import { STATE_STATUS } from "constants";
import "styles/drawer-overrides.css";
import "styles/tabs.css";
import companyDocumentChecklist from "../../templates/db-onboarding/company-document-checklist";
import ProceedAndReferActionModal from "../../templates/db-onboarding/action-modal";
import { DBOnBoardingService } from "../../services";
import CibilDetailTable from "../../templates/db-onboarding/cibil-detail-table";
import { addRequestRemarks, fetchCompanyChecklist, fetchDocumentTypes, fetchWorkflowCaseDetail, clearCompanyAllMpa, clearWorkflowCaseDetail, fetchCompanyBackground, fetchDeviationMatrix} from "store/actions";
import { dbOnboardingInvalidateDocumentHandler } from "../../store/actions/db-onboarding-actions";
import CompanyComments from "../../templates/db-onboarding/company-comments";
import financialAnalysisTab from "../../templates/case-details-tabs/financial-analysis-tab";
import CompanyAssessmentReviewReport from "./company-assesment-review-report";
import { CompanyCreditParameters } from "./company-credit-parameters";
import companyDocumentReviewTab from "../../templates/case-details-tabs/company-document-review-tab";
import companyFinancialAnalysisTab from "../../templates/case-details-tabs/company-financial-analysis-tab";
import { ONBOARDING_STAGES } from "constants/enums";
import DBMpaRequest from "./modules/mpa-request/mpa-request-db";

const Description = Descriptions.Item;

const { TabPane } = Tabs;

const db_onboarding_stages = {
    "38" : "Docs Pending",
    "39" : "Docs Review",
    "40" : "eSign Pending",
    "41" : "eSign Completed"
};
const tabs = new OrderedMap({
    
    cases: {
        key: "cases",
        label: "Cases",
        component: CompanyCasesDisplay,
        permission: "page_company_profile",
        check_d2r : false,
    },
    profile: {
        key: "profile",
        label: "Profile",
        component: CompanyProfileDisplay,
        permission: "page_company_profile",
        check_d2r : false,
    },
    dbMpaRequest: {
        key: "dbMpaRequest",
        label: "MPA Request",
        component: DBMpaRequest,
        permission: "page_company_profile",
        check_d2r : false,
    },
    details: {
        key: "details",
        label: "Details",
        component: CompanyDetailsDisplay,
        permission: "page_company_details",
        check_d2r : false,
    },
    // attachments: {
    //     key: "attachments",
    //     label: "Attachments",
    //     component: CompanyAttachmentsDisplay,
    //     permission: "page_company_documents",
    //     check_d2r : false,
    // },
    attachments: {
        key: "attachments",
        label: "Attachments",
        component: companyDocumentReviewTab,
        permission: "page_company_documents",
        check_d2r : false,
    },
    schemeDetails: {
        key: "schemeDetails",
        label: "Scheme Details",
        component: CompanySchemeDetailsDisplay,
        permission: "page_company_scheme",
        check_d2r : false,
    },
    casesAsSeller: {
        key: "casesAsSeller",
        label: "Cases As Seller",
        component: CompanyCasesAsSellerDisplay,
        permission: "page_cases_as_seller_view",
        check_d2r : false,
    },
    syncRequest: {
        key: "syncRequest",
        label: "Data Sync or Ledger Upload",
        component: CompanyDataSyncDisplay,
        permission: "page_company_sync_request",
        check_d2r : false,
    },
    agreementTab: {
        key: "agreementTab",
        label: "Agreement",
        component: AgreementTab,
        permission: "page_company_agreement",
        check_d2r : false,
    },
    esignTab: {
        key: "esignTab",
        label: "Esign Tab",
        component: EsignTab,
        permission: "db_mou_trigger",
        check_d2r : false,
    },
   
    companyLedgerMaster: {
        key: "companyLedgerMaster",
        label: "Ledger Masters",
        component: CompanyLedgerMaster,
        permission: "page_company_ledger_master",
        check_d2r : false,
    },
    visibilitySheet: {
        key: "visibilitySheet",
        label: "Visibility Sheet",
        component: visibilitySheet,
        permission: "page_company_ledger_master",
        check_d2r : false,
    },
    financialAnalysis : {
        key: "financialAnalysis",
        label: "Financial Analysis",
        component: companyFinancialAnalysisTab,
        permission: "page_financial_analysis",
        check_d2r : true,
    },
    assessmentReport : {
        key: "D2RAssessmentReport",
        label: "D2R Assessment Report",
        component: CompanyAssessmentReviewReport,
        permission: "page_company_credit_assessment",
        check_d2r : true,
    },

    creditParameters : {
        key: "creditParameters",
        label: "Credit Parameters",
        component: CompanyCreditParameters,
        permission: "page_company_cibil_parameter",
        check_d2r : true,
    },
});

const dbOnboardingTabs = new OrderedMap({
    profile: {
        key: "profile",
        label: "Profile",
        component: CompanyProfileDisplay,
        permission: "page_company_profile"
    },
    attachments: {
        key: "attachments",
        label: "Docs Review",
        component: CompanyAttachmentsDisplay,
        permission: "page_documents"
    },
    documentChecklist: {
        key: "documentChecklist",
        label: "Document Checklist",
        component: companyDocumentChecklist,
        permission: "page_checklist",
    },
    creditAppraisal: {
        key: "creditAppraisal",
        label: "Credit Appraisal",
        component: CibilDetailTable,
        permission: "page_credit_appraisal",
    },
    riskControl: {
        key: "riskControl",
        label: "Risk Control",
        component: DBRiskControl,
        permission: "page_company_profile",
    },
    esignTab: {
        key: "esignTab",
        label: "Esign Tab",
        component: EsignTab,
        permission: "db_mou_trigger"
    },
});

const anchorOnboardingTabs = new OrderedMap({
    
    profile: {
        key: "profile",
        label: "Profile",
        component: CompanyProfileDisplay,
        permission: "page_company_profile"
    },
    mpaRequest: {
        key: "mpaRequest",
        label: "MPA Request",
        component: MpaRequest,
        permission: "page_company_profile",
        check_d2r : false,
    },
    deviationMatrixReview: {
        key: "deviationMatrixReview",
        label: "Deviation Matrix Review",
        component: DeviationMatrixReview,
        permission: "page_company_profile",
        check_d2r : false,
    },
    details: {
        key: "details",
        label: "Details",
        component: CompanyDetailsDisplay,
        permission: "page_company_details",
        check_d2r : false,
    },
    attachments: {
        key: "attachments",
        label: "Docs Review",
        component: CompanyAttachmentsDisplay,
        permission: "page_documents"
    },
    schemeDetails: {
        key: "schemeDetails",
        label: "Scheme Details",
        component: CompanySchemeDetailsDisplay,
        permission: "page_company_scheme",
        check_d2r : false,
    },
    esignTab: {
        key: "esignTab",
        label: "Esign Tab",
        component: EsignTab,
        permission: "db_mou_trigger",
        check_d2r : false,
    },
    cases: {
        key: "cases",
        label: "All Cases",
        component: CompanyCasesDisplay,
        permission: "page_company_profile",
        check_d2r : false,
    }  
});

class CompanyDetailsDrawer extends React.Component {
    state = {
        activeKey: null,
        isDBOnBoarding: false,
        commentsDrawerView : false,
        stage : "",
        referback : false,
        anchorOnboarding : false,
        loadingBtn: false
    }
    componentDidMount() {
        this.props.fetchEnums();
        this.props.clearWorkflowCaseDetail();
        const searchParams = QueryString.parse(window.location.search);
        if (searchParams.source == "db-onboarding") {
            this.props.fetchCompanyChecklist(this.props.companyId);        
            if (!this.props.attachments || this.props.attachments.get("status", STATE_STATUS.UNFETCHED) === STATE_STATUS.UNFETCHED) {
                this.props.fetchCompanyLosAttachments(this.props.companyId);
            }
            this.setState({
                isDBOnBoarding: true,
                stage : searchParams.stage,
            });
        } else if (searchParams.source == "anchor-onboarding") {
            this.props.fetchWorkflowCaseDetail(searchParams.action_detail_id);
            this.props.fetchCompanyBackground(this.props.companyId, searchParams.mpa_id);
            this.props.fetchCompanyChecklist(this.props.companyId);        
            if (!this.props.attachments || this.props.attachments.get("status", STATE_STATUS.UNFETCHED) === STATE_STATUS.UNFETCHED) {
                this.props.fetchCompanyLosAttachments(this.props.companyId, true);
            }
            this.setState({
                anchorOnboarding: true,
                stage : searchParams.stage,

            });
        } else {
            this.setState({
                anchorOnboarding: false,
                isDBOnBoarding: false
            });
        }
        if (this.props.status === STATE_STATUS.UNFETCHED) {
            this.props.fetchCompanyLosProfile(this.props.companyId);
        }
        this.fetchCompanyMpa();
    }

    fetchCompanyMpa = () => {
        this.props.fetchCompanyAllMpa(this.props.companyId)
    }

    componentDidUpdate(prevProps){
        if(this.props.onboardingCaseDetailStatus == STATE_STATUS.FETCHED && prevProps.onboardingCaseDetailStatus == STATE_STATUS.FETCHING){
            const current_user = this.props.onboardingCaseDetail && this.props.onboardingCaseDetail.getAssignedUser() && this.props.onboardingCaseDetail.getAssignedUser()['id']
            if(current_user != this.props.userId){
                message.info("You need to assign the case to yourself to make any changes.");
            }
        }
        if (prevProps.pendencyStatus == STATE_STATUS.FETCHING && this.props.pendencyStatus == STATE_STATUS.FETCHED) {
            this.proceedModal();
        }
    }

    getChecklistDocuments(arr  , arrayResponse = false){
        let postSanctionDocuments = (arr["post-sanction"] && Object.keys(arr["post-sanction"]).length) ? Object.values(arr["post-sanction"]).map(_ => _.value && Object.values(_.value)) : [];
        let preSanctionApplicantsDocuments = (arr["pre-sanction"] && Object.keys(arr["pre-sanction"]["applicants"]).length )? arr["pre-sanction"]["applicants"]["value"] : [];
        let preSanctionEntityDocuments = Object.keys(arr["pre-sanction"]["entity"]).length ? arr["pre-sanction"]["entity"]["value"] : {};
        
        preSanctionApplicantsDocuments = preSanctionApplicantsDocuments.map(_ => Object.values(_)).flat().filter(__ => __.type == "doc");
        if(arrayResponse){
            return [...postSanctionDocuments , ...preSanctionApplicantsDocuments , ...Object.values(preSanctionEntityDocuments)];
        }else{
            return {"postSanctionDocuments" : postSanctionDocuments , "preSanctionApplicantsDocuments" : preSanctionApplicantsDocuments , "preSanctionEntityDocuments" : preSanctionEntityDocuments};
        }
    }
    getAttachments() {
        if (this.props.attachments && this.props.attachments.get("data")) {
            let documents = List(this.props.attachments.get("data")).groupBy(_ => _.document ? _.document.id : "");
            let groupedDocs = documents.map(_ => _.reduce((a, b) => {
                if(b.document && b.document.id == 8){
                    let aadharFront = documents.get(8).filter(_ => _.document_option == 12).reduce((a,b) => {
                        return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                    });
                    let aadharback = documents.get(8).filter(_ => _.document_option == 13).reduce((a,b) => {
                        return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                    });
                    return [aadharFront, aadharback];
                }else{
                    return new Date(a.create_date) > new Date(b.create_date) ? a : b;
                }
            }));
            return List(groupedDocs.toList().toJS().flat());
        }
        return List();
    }


    closeDrawer = () => {
        if (this.state.isDBOnBoarding || this.state.anchorOnboarding) {
            this.setState({
                stage : "",
                isDBOnBoarding: false,
                referback : false,   
                anchorOnboarding : false    
            });
            this.props.history.goBack();
        } else {
            this.props.history.replace("/app/companies");
        }
    }

    goBack = () => {
        this.closeDrawer();
    }

    referBack = () => {
        this.setState({
            referback : true,
            proceedOrReferModal : true,
        });
    }

    proceedModalWrapper = () => {
        const searchParams = QueryString.parse(window.location.search);

        if(!this.state.proceedOrReferModal && searchParams.source == "anchor-onboarding"){
            this.fetchPendency();
        }else{
            this.proceedModal()
        }
    }


    proceedModal = () => {
        this.setState({
            referback : false,
            proceedOrReferModal: !this.state.proceedOrReferModal
        });     
    }

    checkD2REligible(){
        return this.props.profile.getIn(["data", "is_d2r_db"]);
    }


    getTags(){
        if(this.state.anchorOnboarding){
            const case_id = this.props.onboardingCaseDetail.get('id');
            return [<Tag>Case ID - {case_id}</Tag>, <Tag>{this.props.onboardingCaseDetail?.getStageName()}</Tag>, 
            <Tag>{this.props.onboardingCaseDetail.getProductName()}</Tag>,<Tag>{this.props.allMpaDetails.get("data")[0]?.mpa_approval?.company?.corporation_type}</Tag>,
        ]
        }
        if(this.state.isDBOnBoarding && this.checkD2REligible()){
            return [<Tag color="blue">{db_onboarding_stages[this.state.stage]}</Tag>, <Tag color="blue">D2R</Tag>];
        }else if(this.state.isDBOnBoarding){
            return [<Tag color="blue">{db_onboarding_stages[this.state.stage]}</Tag>];
        }else if(this.checkD2REligible()){
            return [<Tag color="blue">D2R</Tag>];
        }
    }

    getHeaderExtra = () => {        
        if(this.state.anchorOnboarding){
            const current_user = this.props.onboardingCaseDetail && this.props.onboardingCaseDetail.getAssignedUser() && this.props.onboardingCaseDetail.getAssignedUser()['id']
            return [this.getPageHeaderContent() ,
                this.state.anchorOnboarding  && <Button
                    key={"case-notes"}
                    type={"default"}
                    onClick={() => this.setState({
                        commentsDrawerView : true,
                        referback : false,
                    })}
                >
                    Comments
                </Button>,
                (this.state.anchorOnboarding
                    && ONBOARDING_STAGES.get('docs_pending') != this.state.stage
                    && ONBOARDING_STAGES.get('r2d_completed') != this.state.stage
                    && this.props.userId == current_user)
                && <Button onClick={this.referBack}>
                    Refer Back
                </Button>,
                (this.state.anchorOnboarding && ONBOARDING_STAGES.get('r2d_completed') != this.state.stage &&
                    this.props.userId == current_user) &&
                <Button onClick={this.proceedModalWrapper}>Proceed</Button>,
            ]
        }else if(this.state.isDBOnBoarding){
            return [this.getPageHeaderContent() ,
                this.state.isDBOnBoarding  && <Button
                    key={"case-notes"}
                    type={"default"}
                    onClick={() => this.setState({
                        commentsDrawerView : true,
                        referback : false,
                    })}
                >
                    Comments
                </Button>,
                this.state.isDBOnBoarding && this.checkPermission() &&  db_onboarding_stages[this.state.stage] == "Docs Review" && <Button onClick={this.referBack}>
                Refer Back
                </Button>,
                this.state.isDBOnBoarding && this.checkPermission() && db_onboarding_stages[this.state.stage] != "eSign Completed" && <Button onClick={this.proceedModal}>Proceed</Button>,
                ,
            ]
        }
    }


    fetchPendency = () => {
        const searchParams = QueryString.parse(window.location.search);
        this.props.fetchCasePendencyDetail(searchParams.action_detail_id)
    }

    getPageHeader = () => {
        const companyName = this.getCompanyName();
        if (companyName) {
            return <PageHeader
                tags={this.getTags()}
                className={"fixHeader"}
                ghost={true}
                onBack={this.goBack}
                title={this.getCompanyName()}
                subTitle={this.props.profile.getIn(["data", "gstin"])}
                extra={this.getHeaderExtra()}
            />;
        }
        return null;
    }

    getPageHeaderContent = () => {
        // return this.getDescriptions();
        return [
            <>{(this.props.profile.getIn(["data"]) || {}).primaryDescriptionList.map((value, key) => <div className={"d-flex flex-column"} key={key}>
                <span>{value}</span>
                <span>{key}</span></div>
            ).toList()}</>        
        ];
    }
    // getDescriptions = () => {
    //     const primaryDescription = (this.props.profile.getIn(["data"])||{}).primaryDescriptionList;
    //     return(<Descriptions layout="vertical">
    //         {primaryDescription.map((value, key) => <Descriptions.Item key={key} label={value}>{key}</Descriptions.Item>).toList()}
    //     </Descriptions>);
    // }
    getCompanyName = () => {
        if (!this.props.companyId || this.props.status !== STATE_STATUS.FETCHED) {
            return null;
        }
        return this.props.profile && this.props.profile.getIn(["data", "name"]);
    }

    onChange = key => {
        if (key == "casesAsSeller") {
            this.props.fetchCaseSellerList();
        }
        this.setState({
            activeKey: key
        });
    }

    //pass data in specific tab
    getContentProps = tabName => {
        switch (tabName) {
        case "Document Checklist":
            return {
                openAsTab: true
            };
        case "Credit Appraisal": {
            return {
                companyId: this.props.companyId,
                associate: this.props.profile.getIn(["data", "associates"])
            };
        }
        case "Profile" : {
            this.state.isDBOnBoarding;
        }
        case "Docs Review": {
            return {
                companyId: this.props.companyId,
                isDBOnBoarding: this.state.isDBOnBoarding,
                anchorOnboarding: this.state.anchorOnboarding
            };
        }
        }
    }

    moveToSpecificTab = (tab, data) => {
        const record = data?.mpa_approval;
        this.setState({
            activeKey: tab,
            anchorOnboarding: true
        }, ()=>{
            this.props.history.push(`/app/companies/${record.company?.id}/?source=anchor-onboarding&stage=${record?.action_detail?.current_action_task?.this_stage?.id}&action_detail_id=${record?.action_detail?.id}&mpa_id=${record?.id}&action_task_id=${record?.action_detail?.current_action_task?.id}`)
        })
    }

    getTabs() {
        const searchParams = QueryString.parse(window.location.search);
        const mpa_id = searchParams.mpa_id;
        const filterTable = this.state.isDBOnBoarding ? dbOnboardingTabs : this.state.anchorOnboarding ? anchorOnboardingTabs :  this.checkD2REligible() ? tabs :   tabs.filter(_ => !_.check_d2r);
        const firstTab = filterTable.first();
        return (<Tabs
            tabBarStyle={{ backgroundColor: "#fff" }}
            className={"fixed-tabs"}
            animated={false}
            activeKey={this.state.activeKey || firstTab.key}
            onChange={this.onChange}
        >

            {
                filterTable
                    .filter(_ => {
                        if (_.permission === "page_company_agreement" && Number(this.props.userId) === Number(this.props.primaryRM)) {
                            return true;
                        }
                        if (_.key === "syncRequest" && this.props.companyType !== 2) {
                            return false;
                        }
                        if (_.key === "mpaRequest" && (this.props.companyType === 3 || this.props.companyType === 2 && this.props.profile.getIn(["data", "is_mpa_approval_required"]) === false)) {
                            return false;
                        }
                        if(_.key === "dbMpaRequest" && (this.props.companyType != 2 || this.props.userEmail != "abhishek.verma@progcap.com") ){
                            return false;
                        }
                        if(_.key == "cases" && this.props.companyType != 1){
                            return false;
                        }
                        if(_.key == "esignTab" && this.state.anchorOnboarding && ["48", "49", "50"].includes(searchParams.stage)){
                            return false;
                        }
                        if(_.key == "deviationMatrixReview" && this.state.anchorOnboarding && ["48","49"].includes(searchParams.stage)){
                            return false;
                        }
                        return this.props.permissions && this.props.permissions.get(_.permission);
                    })
                    .map(_ => {
                        const Comp = _.component;
                        return (<TabPane className={"fixTab"} key={_.key} tab={_.label}>
                            <Comp key={_.key} {...this.props} {...this.getContentProps(_.label)} setCurrentMpaId={this.setCurrentMpaId} 
                                anchorOnboarding={this.state.anchorOnboarding}
                                // currentMpaId={this.state.currentMpaId || this.props.onboardingCaseDetail.getIn(['mpa_approval', 'id'])}
                                currentMpaId={mpa_id}
                                getCurrentMpaData={this.props.onboardingCaseDetail}
                                moveToSpecificTab={this.moveToSpecificTab}
                                allMpaDetails = {this.props.allMpaDetails}
                                companyBackgroundData = {this.props.companyBackgroundData}
                                fetchCompanyMpa = {this.fetchCompanyMpa}
                                companyType = {this.props.companyType}
                                userGroups={this.props.userGroups}
                                permissions={this.props.permissions}
                            />
                        </TabPane>);
                    })
                    .toList()
                    .toArray()
            }
        </Tabs>);
    }
    getProgressHandler() {
        return (<Result title={"Setting up Company info..."} icon={<Icon type={"loading"} />} />);
    }
    getErrorHandler() {
        return (<Result title={500} subtitle={"Sorry, we are facing some issues."} />);
    }
    getResultNotFound() {
        return (<Result title={404} subtitle={"Sorry, the page you visited does not exist."} />);
    }

    getBody = () => {
        /*eslint-disable*/
        switch (this.props.status) {
            case STATE_STATUS.FETCHED:
                return this.getTabs();
            case STATE_STATUS.UNFETCHED:
            case STATE_STATUS.FETCHING:
                return this.getProgressHandler();
            case STATE_STATUS.FETCH_FAILED:
                return this.getErrorHandler();
            default:
                return this.getResultNotFound();
        }
        /*eslint-enable*/
    }

    closeReferOrProceedModal = () => {
        this.setState({
            proceedOrReferModal : false
        });
    }

    onReferAndProceed = (remarks) => {
            const searchParams = QueryString.parse(window.location.search);

            const payload = {
                "company_id": this.props.companyId,
                "remarks": remarks,
                action_task_id : searchParams.action_task_id
                // "action_task_id": this.state.actionTaskId,
            };
            if(remarks){
                this.setState({loadingBtn:true});
                let type= this.state.referback == true ?  "refer" : "proceed";
                DBOnBoardingService.proceedCase(payload , type).then((resp) => {
                    if(resp.data["non_field_error"]){
                        message.error("Something Went Wrong!");
                    }else{
                        this.closeReferOrProceedModal();
                        this.goBack();
                        this.setState({
                            referback : false
                        });
                    }
                }).catch((err) => { 
                    if (err.non_field_errors) {
                        message.error(err.non_field_errors[0]);
                    } else {
                        message.error("Something went wrong!");
                    }
    
                }).finally(()=>{
                    this.setState({loadingBtn: false});
                })    
            }
    }
    handleCompanyTaskModal = () => {
        this.setState({
            commentsDrawerView : !this.state.commentsDrawerView
        });
    }

    checkPermission = () => {
        if(this.getActiveCaseDataDB().size && this.getActiveCaseDataDB().getIn([0 , "assigned_user"])){
            if(Number(this.props.userId)  == Number(this.getActiveCaseDataDB().getIn([0 , "assigned_user" , "id"]))){
                return true;
            }
        }
        return false;
    }

    canProceddOrNot = (arr) => {
        if(Object.keys(arr).length){
            if(db_onboarding_stages[this.state.stage] == "Docs Pending"){
                if(
                    Object.values(this.getChecklistDocuments(arr)["preSanctionEntityDocuments"]).some(_ => _.value == false && _.is_mandatory)
                    || this.getChecklistDocuments(arr)["preSanctionApplicantsDocuments"].some(_ => _.value == false && _.is_mandatory) 
                    || this.getChecklistDocuments(arr)["postSanctionDocuments"].flat().some(_ => _.value == false && _.is_mandatory)
                ){return false;}
                return true;
            }else if(db_onboarding_stages[this.state.stage] == "Docs Review"){
                const checklistDocsCheck = this.getChecklistDocuments(arr, true).find(el=>el.is_mandatory ===true && el.value === false);
                if(!checklistDocsCheck){
                    return true;
                }
            }else if(this.props.profile.getIn(["data" , "esign_status"]) == "Signed" && db_onboarding_stages[this.state.stage] == "eSign Pending"){
                return true;
            }
        }
        return false;  
    }

    getActiveCaseDataDB = () => {
        if(this.props.dbListFetchStatus == STATE_STATUS.FETCHED){
            return this.props.dbList.filter(_ => Number(_.company_id) == Number(this.props.companyId));
        }
        if(this.props.dbListFetchStatus == STATE_STATUS.UNFETCHED){
            this.props.history.push("/app/inbox");
        }
        return List();
    }

    setCurrentMpaId = (id) => {
        this.setState({
            currentMpaId : id
        })
    }    
    

    render() {
        
        return (<Drawer
            visible={true}
            title={this.getPageHeader()}
            headerStyle={{
                padding: 0
            }}
            bodyStyle={{
                backgroundColor: "#fafafa",
                height: "calc(100% - 91px)"
            }}
            className={"scrollable-drawer"}
            closable={false}
            placement={"right"}
            width={"100%"}
        >
            <CompanyComments 
                stageId = {this.state.stage}
                visible={this.state.commentsDrawerView} 
                closeCompanyTaskModal={this.handleCompanyTaskModal}
                userId={this.props.userId}
            />
            <ProceedAndReferActionModal
                modalVisible={this.state.proceedOrReferModal}
                closeModal={this.closeReferOrProceedModal}
                onProceed={this.onReferAndProceed}
                referback = {this.state.referback}
                loadingBtn={this.state.loadingBtn}
                pendency={this.props.pendencyData || List() }
            />
            {this.state.isDBOnBoarding && this.props.profile && this.props.profile.get("data") &&  <Descriptions column={4} className={"summary"}>
                <Description label={"Constitution"}>{this.props.profile.get("data").constitutionType}</Description>
                <Description label={"Primary RM"}>{this.props.profile.get("data").primary_relationship_manager &&this.props.profile.get("data").primary_relationship_manager.full_name}</Description>
                <Description label={"Primary Industry"}>{this.props.profile.get("data").industry?.name}</Description>
                <Description label={"Primary Anchor"}>{this.props.detail && this.props.detail.get("data") && this.props.detail.get("data").program_anchor?.name}</Description>
            </Descriptions>}
            {this.getBody()}
        </Drawer>);
    }
}

CompanyDetailsDrawer.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    profile: PropTypes.object,
    detail: PropTypes.object,
    erps: PropTypes.object,
    annualTurnovers: PropTypes.object,
    bankingFacilities: PropTypes.object,
    brands: PropTypes.object,
    attachments: PropTypes.object,
    companyId: PropTypes.string,
    companyDetails: PropTypes.object,
    fetchCompanyLosProfile: PropTypes.func,
    fetchDbRiskControlDetail: PropTypes.func,
    fetchCompanyLosAttachments: PropTypes.func,
    fetchCompanyLosDetail: PropTypes.func,
    updateCompanyLosProfile: PropTypes.func,
    updateCompanyDisbursalAccount: PropTypes.func,
    updateCompanyLosDetail: PropTypes.func,
    updateCompanyLosAttachments: PropTypes.func,
    status: PropTypes.string,
    fetchCompanyLosErps: PropTypes.func,
    updateCompanyLosErps: PropTypes.func,
    fetchCompanyLosAnnualTurnovers: PropTypes.func,
    updateCompanyLosAnnualTurnovers: PropTypes.func,
    fetchCompanyLosBankingFacilities: PropTypes.func,
    updateCompanyLosBankingFacilities: PropTypes.func,
    fetchCompanyLosBrands: PropTypes.func,
    updateCompanyLosBrands: PropTypes.func,
    updateCaseType: PropTypes.func,
    permissions: PropTypes.object,
    updateCompanyAddress: PropTypes.func,
    addressesStatus: PropTypes.string,
    uploadCompanyLosAttachment: PropTypes.func,
    primaryRM: PropTypes.number,
    userId: PropTypes.number,
    validateDocument: PropTypes.func,
    addRetailerMapping: PropTypes.func,
    fetchRetailerMapping: PropTypes.func,
    retailerMapping: PropTypes.array,
    retailerMappingStatus: PropTypes.string,
    retailerMappingError: PropTypes.object,
    fetchSellerLedgerMaster: PropTypes.func,
    updateSellerLedgerMaster: PropTypes.func,
    sellerLedgerMasters: PropTypes.func,
    fetchCompanyVisibilitySheetData: PropTypes.func,
    fetchCaseSellerList: PropTypes.func,
    companyType: PropTypes.number,
    addRequestRemarks: PropTypes.func,
    fetchWorkflowCaseDetail: PropTypes.func,
    fetchCompanyBackground: PropTypes.func,
    fetchDeviationMatrix: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    const { match: { params } } = props;
    if (!params.companyId) {
        return {
            companyId: null,
            profile: null,
            detail: null,
            erps: null,
            annualTurnovers: null,
            bankingFacilities: null,
            brands: null,
            attachments: null,
            status: STATE_STATUS.NOT_FOUND,
            companyDetails: null
        };
    }
    return {
        checklist: state.companies.getIn(["checklist", "data"]),
        userId: state.user.getIn(["data", "id"]),
        userEmail: state.user.getIn(["data", "email"]),
        companyId: params.companyId,
        company: state.companies.getIn([params.companyId, "data"]),
        companyDocStatus: state.documents.getIn(["company_documents"]),
        profile: state.companyLosProfiles.getIn(["profiles", params.companyId]),
        dbRiskControlDetail: state.companyLosProfiles.getIn(["db_risk_control_details", params.companyId]),
        detail: state.companyLosProfiles.getIn(["details", params.companyId]),
        erps: state.companyLosProfiles.getIn(["erps", params.companyId]),
        annualturnovers: state.companyLosProfiles.getIn(["annualTurnovers", params.companyId]),
        bankingfacilities: state.companyLosProfiles.getIn(["bankingFacilities", params.companyId]),
        brands: state.companyLosProfiles.getIn(["brands", params.companyId]),
        attachments: state.companyLosProfiles.getIn(["attachments", params.companyId], Map({})),
        status: state.companyLosProfiles.get(params.companyId) || STATE_STATUS.UNFETCHED,
        permissions: state.user.get("permissions"),
        addressesStatus: state.companyLosProfiles.getIn(["profiles", params.companyId, "addressesStatus"]),
        primaryRM: state.companyLosProfiles.getIn(["profiles", params.companyId, "data", "primary_relationship_manager", "id"]),
        retailerMapping: state.companyLosProfiles.getIn(["retailer_mapping", params.companyId, "data"]),
        retailerMappingStatus: state.companyLosProfiles.getIn(["retailer_mapping", params.companyId, "status"]),
        retailerMappingError: state.companyLosProfiles.getIn(["retailer_mapping", params.companyId, "error"]),
        sellerLedgerMasters: state.companyLosProfiles.getIn(["ledgerMasters", params.companyId, "data"]),
        companyDetails: state.companyLosProfiles.getIn(["profiles", props.companyId, "data"]),
        visibilitySheetData: state.companyLosProfiles.getIn(["visibility_data", params.companyId, "data"]),
        visibilitySheetDataStatus: state.companyLosProfiles.getIn(["visibility_data", params.companyId, "status"]),
        companyType: state.companyLosProfiles.getIn(["profiles", params.companyId, "data", "type"]),
        docMasterListStatus: state.documents.getIn([
            "documentsMasterList",
            "status"
        ]),
        deleteDocumentStatus : state.dbOnBoarding.get("deleteDocumentState"),
        dbList : List(state.dbOnBoarding.get("dbOnBoardingList") , []),
        dbListFetchStatus : state.dbOnBoarding.get("status"),
        onboardingCaseDetail : state.onboardingData.getIn(['caseDetails', 'data']),
        onboardingCaseDetailStatus : state.onboardingData.getIn(['caseDetails', 'status']),
        pendencyStatus: state.onboardingData.getIn(['pendency', 'status']),
        pendencyData: state.onboardingData.getIn(['pendency', 'data']),
        allMpaDetails : state.companies.get("allMpaDetails"), 
        companyBackgroundData : state.onboardingData.getIn(["companyBackground", "data"]), 
        all_enums : state.companies.get("enums"),
        userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchCompanyLosProfile,
    fetchDbRiskControlDetail,
    fetchCompanyLosAttachments,
    fetchCompanyLosDetail,
    updateCompanyLosAttachments,
    updateCompanyLosDetail,
    updateCompanyLosProfile,
    updateCompanyDisbursalAccount,
    fetchCompanyLosErps,
    updateCompanyLosErps,
    fetchCompanyLosAnnualTurnovers,
    updateCompanyLosAnnualTurnovers,
    fetchCompanyLosBankingFacilities,
    updateCompanyLosBankingFacilities,
    fetchCompanyLosBrands,
    updateCompanyLosBrands,
    updateCaseType,
    updateCompanyAddress,
    uploadCompanyLosAttachment,
    validateDocument,
    addRetailerMapping,
    fetchRetailerMapping,
    fetchSellerLedgerMaster,
    updateSellerLedgerMaster,
    fetchCompanyVisibilitySheetData,
    fetchCaseSellerList,
    addRequestRemarks,
    fetchDocumentTypes,
    dbOnboardingInvalidateDocumentHandler,
    invalidateDocument,
    fetchCompanyChecklist,
    fetchWorkflowCaseDetail,
    fetchCompanyBackground,
    fetchCasePendencyDetail,
    fetchCompanyAllMpa,
    clearCompanyAllMpa,
    clearWorkflowCaseDetail,
    fetchEnums
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetailsDrawer);